import React from 'react';
import {FieldArray, FieldArrayConfig, FieldArrayRenderProps} from "formik";
import Button from "components/Button";
import {PlusIcon} from "@heroicons/react/solid";
import Disclosure from "components/Disclosure";
import AdvisoryEditor from "./AdvisoryEditor";
import {TrailAdvisory} from "types/TrailAdvisory";

export type AdvisoryListFieldProps = FieldArrayConfig & {
  advisories: Array<TrailAdvisory>
  dark?: boolean
}

function AdvisoryListField({advisories, dark, ...props}: AdvisoryListFieldProps) {
  return (
    <FieldArray {...props}>
      {({push, remove, form}: FieldArrayRenderProps) => {

        const advisoriesData = props.name
          .split('.')
          .reduce((object, key) => object?.[key], form.values) as Array<TrailAdvisory> | undefined

        return (
          <>
            <ul className="space-y-4">
              {advisoriesData?.map((advisory, index) => (
                <li key={index}>
                  <Disclosure name={advisory.title} defaultOpen={!advisory.id} dark={dark}>
                    <AdvisoryEditor
                      name={props.name}
                      index={index}
                      image={advisories[index]?.image}
                      onRemove={remove}
                    />
                  </Disclosure>
                </li>
              ))}
            </ul>

            <div className={advisoriesData?.length ? 'mt-4' : ''}>
              <Button
                color={Button.colors.SECONDARY}
                icon={PlusIcon}
                size={Button.sizes.TINY}
                onClick={() => push({title: '', body: ''})}
              >
                Add Advisory
              </Button>
            </div>
          </>
        )
      }}
    </FieldArray>
  );
}

export default AdvisoryListField;